module.exports = __webpack_public_path__ + "img/amazon-pay.6b26e08f.svg";